import { Modal, Button } from "antd";
import { InsightProps } from "./insights";
import { useUser } from "@/contexts/UserContext";
import { useScopeParams } from "@/hooks/useScopeParams";
import { getColumnTitle } from "@/utils/tableHelpers";
import { getUserRoleForTrial } from "./insights.utils";

type ShareInsightModalProps = {
  insight: InsightProps;
  isOpen: boolean;
  onClose: () => void;
  onShare: (insightId: string) => void;
  onStopSharing: (insightId: string) => void;
  isLoading?: boolean;
};

export default function ShareInsightModal({
  insight,
  isOpen,
  onClose,
  onShare,
  onStopSharing,
  isLoading = false,
}: ShareInsightModalProps) {
  const { userInfo } = useUser();
  const { id: trialId } = useScopeParams();
  const trialRole = getUserRoleForTrial(userInfo, trialId);
  const isShared = insight?.is_shared;

  return (
    <Modal
      title={isShared ? "Unshare Insight" : "Share Insight"}
      open={isOpen}
      onCancel={onClose}
      width={400}
      centered
      footer={
        isShared ? (
          <div className="flex justify-between items-center">
            <Button
              className="bg-[rgba(255,216,216,0.40)] text-[#CC0404] border-none rounded-sm hover:bg-[rgba(255,216,216,0.60)]! hover:text-[#CC0404]!"
              onClick={() => {
                onStopSharing(insight.id);
                onClose();
              }}
              loading={isLoading}
            >
              Unshare Insight
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </div>
        ) : (
          <div className="flex justify-end gap-2">
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="primary"
              onClick={() => {
                onShare(insight.id);
                onClose();
              }}
              loading={isLoading}
            >
              Share
            </Button>
          </div>
        )
      }
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-[#2B4752]">
          {isShared
            ? "This insight is currently shared with "
            : "You are about to share this insight with "}
          <span className="font-bold">
            {trialRole ? getColumnTitle(trialRole) : "users"}
          </span>
          {" role users."}
        </p>
      </div>
    </Modal>
  );
}
